/**
 * Sticky add-to-cart bar (tracker PDP-9) — the behavior half of
 * snippets/zager-sticky-atc.liquid. See docs/Features/sticky-add-to-cart.md.
 *
 * Show/hide: live's bar slides down once the buy area leaves the viewport
 * upward and slides back when it returns. An IntersectionObserver on the
 * page's product form reproduces that — visible only while the form is BOTH
 * out of view AND above the viewport (scrolling down past it), never when
 * the form is below (page top on load).
 *
 * Add: the bar submits the page's own product form (requestSubmit), so the
 * add takes whatever path that form already has — the gift module's
 * parent+gifts interception, the 2.3 sold-individually guard, or a native
 * post. No second /cart/add implementation (the Task C adjudication).
 */

/** @returns {HTMLFormElement | null} */
function primaryForm() {
  const byId = document.getElementById('zager-product-form');
  if (byId instanceof HTMLFormElement) return byId;
  const accessoryButton = document.querySelector('button[data-zager-primary-form-button]');
  if (accessoryButton instanceof HTMLButtonElement && accessoryButton.form) return accessoryButton.form;
  const any = document.querySelector('form[action*="/cart/add"]');
  return any instanceof HTMLFormElement ? any : null;
}

function init() {
  const bar = document.querySelector('[data-zager-sticky-atc]');
  if (!(bar instanceof HTMLElement)) return;

  const form = primaryForm();
  if (!form) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
        bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
      }
    },
    { threshold: 0 }
  );
  observer.observe(form);

  bar.querySelector('[data-zager-sticky-add]')?.addEventListener('click', () => {
    form.requestSubmit();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
